// extracted by mini-css-extract-plugin
export default {"laneStyle":"KanbanView_laneStyle__JBqMd"};